import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectPartner } from "../../store/partnerStore";
import { getPartnerLink } from "../theme/partnerLinks";
import "./partnerFooter.scss";

// Pinned full-bleed bar back to the partner's own app — the V2 counterpart to
// the legacy components/Footer.jsx. Same destination, new design, and no
// PoweredBy strip (it isn't in the V2 designs).
function PartnerFooter() {
  const { t } = useTranslation();
  const partner = useSelector(selectPartner);

  return (
    <button
      type="button"
      className="v2-partner-footer"
      onClick={() => window.open(getPartnerLink(partner, "backToPartner"), "_blank")}
    >
      {t("BACK_TO_PARTNER")}
    </button>
  );
}

export default PartnerFooter;
